<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="入口" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag
            ref="tableBoardType"
            v-decorator="['tableBoardType', validatorRules.tableBoardType]"
            :triggerChange="true"
            @change="selectChange($event, 'stoneTypeSelectDict')"
            dictCode="jujia_stone_tabletype,search_name,id"
          />
        </a-form-item>
        <a-form-item label="产品" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag
            ref="jpStoneType"
            v-decorator="['jpStoneType', validatorRules.jpStoneType]"
            :triggerChange="true"
            placeholder="请输入产品"
            :dictCode="stoneTypeSelectDict"
            @change="selectChange($event, 'stoneSeriesSelectDict')"
          />
        </a-form-item>
        <a-form-item label="系列" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag
            ref="jpStoneSeries"
            v-decorator="['jpStoneSeries', validatorRules.jpStoneSeries]"
            :triggerChange="true"
            placeholder="请输入系列"
            :dictCode="stoneSeriesSelectDict"
            @change="selectChange($event, 'flowerColorSelectDict')"
          />
        </a-form-item>
        <a-form-item label="花色" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag
            ref="jpFlowerColor"
            v-decorator="['jpFlowerColor', validatorRules.jpFlowerColor]"
            :triggerChange="true"
            placeholder="请输入花色"
            :dictCode="flowerColorSelectDict"
          />
        </a-form-item>
        <a-form-item label="是否新品" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag
            type="list"
            v-decorator="['newProduct', validatorRules.newProduct]"
            :trigger-change="true"
            dictCode="is_not_new_product"
            placeholder="请选择是否新品"
          />
        </a-form-item>
        <a-form-item label="国产/进口" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag
            type="list"
            v-decorator="['madeFrom', validatorRules.madeFrom]"
            :trigger-change="true"
            dictCode="is_made_from"
            placeholder="请选择国产/进口"
          />
        </a-form-item>
        <a-form-item label="介绍" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-editor v-decorator="['introduce', { trigger: 'input' }]" />
        </a-form-item>
        <a-form-item label="主图路径" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-upload
            v-decorator="['jpStoneMaddress', validatorRules.jpStoneMaddress]"
            :trigger-change="true"
            :uploadData="uploadData1"
            :beforeUpload="beforeUpload"
            fileType="image"
          ></j-upload>
        </a-form-item>
        <a-form-item label="详情图路径" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-upload
            v-decorator="['jpStoneDetailaddress', validatorRules.jpStoneDetailaddress]"
            :trigger-change="true"
            :uploadData="uploadData2"
            :beforeUpload="beforeUpload"
            fileType="image"
          ></j-upload>
        </a-form-item>
        <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea v-decorator="['remarks', validatorRules.remarks]" rows="4" placeholder="请输入备注" />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import { httpAction } from '@/api/manage'
import pick from 'lodash.pick'
import { validateDuplicateValue } from '@/utils/util'
import JUpload from './JUpload'
import JDictSelectTag from '@/components/dict/JDictSelectTag'
import JEditor from './JEditorChangeUrl'

const FILE_TYPE_ALL = 'all'
const FILE_TYPE_IMG = 'image'
const FILE_TYPE_TXT = 'file'
export default {
  name: 'GoldStoneJpglistModal',
  components: {
    JUpload,
    JDictSelectTag,
    JEditor,
  },
  data() {
    return {
      stoneTypeSelectDict: 'jujia_stone_stonetype,search_name,id',
      stoneSeriesSelectDict: 'jujia_stone_stoneseries,search_name,id',
      flowerColorSelectDict: 'jujia_stone_flowercolor,search_name,id',
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {
        tableBoardType: { rules: [{ required: true, message: '请输入入口!' }] },
        jpStoneType: { rules: [] },
        jpStoneSeries: { rules: [] },
        jpFlowerColor: { rules: [] },
        newProduct: { rules: [{ required: true, message: '请选择是否是新品!' }] },
        madeFrom: { rules: [{ required: true, message: '请选择国产/进口!' }] },
        introduce: { rules: [] },
        jpStoneMaddress: { rules: [{ required: true, message: '请上传主图!' }] },
        jpStoneDetailaddress: { rules: [] },
        remarks: { rules: [] },
      },
      url: {
        add: '/jujiastone/goldStoneJpglist/add',
        edit: '/jujiastone/goldStoneJpglist/edit',
      },
    }
  },
  created() {},
  methods: {
    selectChange(values, selectDict) {
      switch (selectDict) {
        case 'stoneTypeSelectDict':
          this.form.resetFields(['jpStoneType', 'jpStoneSeries', 'jpFlowerColor'])
          this[selectDict] = 'jujia_stone_stonetype,search_name,id,parent_id=' + values
          break
        case 'stoneSeriesSelectDict':
          this.form.resetFields(['jpStoneSeries', 'jpFlowerColor'])
          this[selectDict] = "jujia_stone_stoneseries,search_name,id,parent_id='" + values + "'"
          break
        case 'flowerColorSelectDict':
          this.form.resetFields(['jpFlowerColor'])
          this[selectDict] = "jujia_stone_flowercolor,search_name,id,parent_id='" + values + "'"
          break
        default:
          break
      }
      console.log(values)
    },
    add() {
      this.edit({})
    },
    edit(record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'updateTime',
            'tableBoardType',
            'jpStoneType',
            'jpStoneSeries',
            'jpFlowerColor',
            'newProduct',
            'madeFrom',
            'introduce',
            'jpStoneMaddress',
            'jpStoneDetailaddress',
            'remarks'
          )
        )
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'post'
          }
          let formData = Object.assign(this.model, values)
          console.log('表单提交数据', formData)
          httpAction(httpurl, formData, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
              that.close()
            })
        }
      })
    },
    handleCancel() {
      this.close()
    },
    uploadData1() {
      let filepathData = 'goldenstone/' + this.$refs.tableBoardType.getSelectLabels()
      if (this.$refs.jpStoneType.getSelectLabels()) {
        filepathData = filepathData + '/' + this.$refs.jpStoneType.getSelectLabels()
        if (this.$refs.jpStoneSeries.getSelectLabels()) {
          filepathData = filepathData + '/' + this.$refs.jpStoneSeries.getSelectLabels()
          if (this.$refs.jpFlowerColor.getSelectLabels()) {
            filepathData = filepathData + '/' + this.$refs.jpFlowerColor.getSelectLabels()
          }
        }
      }
      return { filePath: filepathData }
    },
    uploadData2() {
      let filepathData = 'detailgoldenstone/' + this.$refs.tableBoardType.getSelectLabels()
      if (this.$refs.jpStoneType.getSelectLabels()) {
        filepathData = filepathData + '/' + this.$refs.jpStoneType.getSelectLabels()
        if (this.$refs.jpStoneSeries.getSelectLabels()) {
          filepathData = filepathData + '/' + this.$refs.jpStoneSeries.getSelectLabels()
          if (this.$refs.jpFlowerColor.getSelectLabels()) {
            filepathData = filepathData + '/' + this.$refs.jpFlowerColor.getSelectLabels()
          }
        }
      }
      return { filePath: filepathData }
    },
    beforeUpload(file, fileList) {
      let values = this.form.getFieldsValue(['tableBoardType'])
      if (!values.tableBoardType) {
        this.$message.warning('请先选择入口')
        console.log(fileList)
        console.log(file)
        fileList.forEach((item, index, input) => {
          if (item.lastModified == file.lastModified) {
            fileList.splice(index, 1)
          }
        })
        return false
      }
      var fileType = file.type
      if (fileType === FILE_TYPE_IMG) {
        if (fileType.indexOf('image') < 0) {
          this.$message.warning('请上传图片')
          return false
        }
      } else if (fileType === FILE_TYPE_TXT) {
        if (fileType.indexOf('image') >= 0) {
          this.$message.warning('请上传文件')
          return false
        }
      }
      //TODO 扩展功能验证文件大小
      return true
    },
  },
}
</script>
